import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { AwardsService } from '../services';
import { awardsKeys } from '../queryKeys';
import { DEFAULT_PAGE_SIZE, clampPage } from '../pagination';

export const useGetCycles = (page = 1) => {
  const safePage = clampPage(page);

  const { data, error, isError, isPending, isFetching } = useQuery({
    queryKey: awardsKeys.cycles(safePage),
    queryFn: () => AwardsService.getCycles(safePage),
    retry: false,
    // Keeps the previous page on screen while the next one loads, so paging
    // does not blank the table. (v4's keepPreviousData: true was removed in v5.)
    placeholderData: keepPreviousData,
  });

  return {
    cycles: data?.items ?? [],
    page: data?.page ?? safePage,
    pageSize: data?.pageSize ?? DEFAULT_PAGE_SIZE,
    totalCount: data?.totalCount ?? 0,
    isPending,
    isFetching,
    isError,
    error,
  };
};
